import { createContext } from "react";

const Tab = createContext({ currentTab: "live-site", setCurrentTab: () => {} });

export default Tab;
